export default __webpack_public_path__ + "static/icon-18-5-ada7db0efcea6970b7f78bc84ca5e0dc.png";